import { AssistantNewReportConversation } from '@@types/models/CreateReport';

import { SingleMessage } from '@domains/new-conversation/atoms/SingleMessage/SingleMessage';
import { ResponseWrapper } from '@domains/new-conversation/molecules/ResponseMessage/ResponseMessage.styled';

interface ResponseMessageProps {
    message: AssistantNewReportConversation;
}

export const ResponseMessage = ({ message }: ResponseMessageProps) => {
    return (
        <>
            {message.assistantResponses?.map((text, index) => (
                <ResponseWrapper key={`Response${index}`}>
                    <SingleMessage showAvatar={index === 0}>
                        {text}
                    </SingleMessage>
                </ResponseWrapper>
            ))}
        </>
    );
};
